import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { Form, Dropdown } from 'semantic-ui-react'
import { get } from '../lib/http';
import { appStore } from '../stores/AppStore';
import { error } from "@glg/cm-shared-lib/browser/logging";

let _cachedTimeZones = [];
const fetchTimeZones = async () => {
  if (_cachedTimeZones.length > 0 ) {
    return _cachedTimeZones;
  }
  try {
    let dbTimeZones = await get("api/lookupdata/getTimeZones");
    dbTimeZones.sort((a, b) => a.NAME.localeCompare(b.NAME));
    const timeZones = dbTimeZones.map(tz => ({ value: tz.NAME, text: tz.NAME_FORMAT.replace('_', ' '), key:tz.NAME_FORMAT }));
    
    // derive user tz and move it to the top of the dropdown    
    const preferredTz = ('Intl' in window && Intl.DateTimeFormat && Intl.DateTimeFormat().resolvedOptions && Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (preferredTz) {
      const preferredIndex = timeZones.findIndex(tz => tz.value === preferredTz);
      if (preferredIndex) {
        timeZones.unshift(<Dropdown.Divider key="divider-tz" />)
        timeZones.unshift(timeZones.splice(preferredIndex + 1, 1)[0]);
      }
    }
    if (timeZones.length > 0) {
      _cachedTimeZones = timeZones;
    }
    return timeZones;
  } catch (ex) {
    error('fetchTimeZones', ex)
    return []
  }
}

export const FormTimeZones = ({ hasError = false }) => {

  const [t] = useTranslation()
  const [options, setOptions] = useState([]);


  useEffect(() => {
    const loadTimeZones = async () => {
      setOptions(await fetchTimeZones());
    }

    loadTimeZones();
  }, []);

  return (
    <Form.Field>
      <Dropdown
        fluid
        placeholder={t('time_zone')}
        disabled={options.length <= 0}
        search
        selection
        closeOnChange
        selectOnNavigation={false}
        selectOnBlur={false}
        options={options}
        onChange={(e, d) => appStore.userSelectedTimeZone = d.value}
        error={hasError}
      />
    </Form.Field>
  )
};

